import { SWRConfiguration } from 'swr';

const swrConfig: SWRConfiguration = {
    refreshInterval: 600000,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    loadingTimeout: 3000,
    onErrorRetry: (error) => {
        // Never retry on 404.
        if (error.status === 404) return;
    },
};

export default swrConfig;
